module.exports = __webpack_public_path__ + "img/videoxin.d45f2fcf.png";